import script from "./ComponenteDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponenteDoc.vue?vue&type=script&setup=true&lang=js"

import "./ComponenteDoc.vue?vue&type=style&index=0&id=1c1fcbdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c1fcbdf"]])

export default __exports__